var React = require('react');

function Tumblr (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.71 70.504c-6.77.185-8.084-4.86-8.138-8.515V35.092h16.982V22.01H29.632V0H17.248c-.204 0-.56.182-.6.645C15.913 7.38 12.83 19.204 0 23.93v11.16h8.558v28.23c0 9.666 6.978 23.398 25.4 23.074 6.215-.11 13.118-2.767 14.642-5.062l-4.067-12.32c-1.572.766-4.58 1.433-6.822 1.5z","transform":"matrix(.992546 .121869 -.121869 .992546 4.480763 -2)","fill":"#5e5e5e","fillRule":"evenodd"}));
}

Tumblr.defaultProps = {"width":"48","height":"88"};

module.exports = Tumblr;

Tumblr.default = Tumblr;
